import React, { useState, useEffect } from "react";
import { Space, Table, Tag, Select,Flex } from 'antd';
import { Link } from "react-router-dom";
import fetchData from "Hooks/useAPI";
import './style.css'
import useAuth from "Hooks/useAuth";

import CardTravel from "./CardTravel";

const CardsAndApi = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [dataSource, setDataSource] = useState([]);
  const [empresa, setEmpresa] = useState("all")
  const [totalData, setTotalData] = useState(0);
  const { logout } = useAuth()

  const URL =`https://adandyou.host/users_app/api/index.php/ticketsdetail`;
  useEffect(() => {
    fetchData(URL, 'GET', null, {}, logout)
    .then(response=>{     
      setDataSource(response.items);
      //setTotalData(response.items);
    })
    .catch((err)=>{
      console.log(err)
    })
    
  }, [currentPage, pageSize,empresa]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <Flex vertical gap={"middle"}>
      
      {dataSource.map((viaje, index) => (
        <CardTravel
          key={index}
          fecha={viaje.created_at}
          unidad={viaje.unidad}
          folio={viaje.folio}
          desde={viaje.origen}
          a={viaje.destino}          
          tarifa={viaje.tarifa}
          empresa={viaje.empresa}
          user_id={viaje.id_user}
          estatus={viaje.estatus}
          califa={viaje.califa || 0}
          user_type={viaje.user_type || 1}
        />
      ))}
      
    </Flex>
  );
};



export default CardsAndApi;